import { render, staticRenderFns } from "./editWageItem.vue?vue&type=template&id=271ccbd4&"
import script from "./editWageItem.vue?vue&type=script&lang=js&"
export * from "./editWageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports